import {
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  TypographyProps,
} from '@mui/material';
import React, { useState } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { TP_COLORS } from '../../../constants';

const bannerStyles = {
  minHeight: { xs: '84px', sm: '50px' },
  position: 'sticky',
  top: { xs: '56px', sm: '64px' },
  zIndex: 5,
  backgroundColor: TP_COLORS.blue.dark,
  padding: '8px 16px',
};

const typoProps: TypographyProps = {
  variant: 'subtitle1',
  color: TP_COLORS.white,
  textAlign: 'center',
  margin: { xs: '0 8px', sm: '0 16px' },
};

const closeButtonStyles = {
  color: TP_COLORS.white,
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  backgroundColor: 'transparent',
  padding: '4px 12px',
};

const TopBanner: React.FC = () => {
  const theme = useTheme();
  const belowMd = useMediaQuery(theme.breakpoints.down('md'));
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Grid container sx={bannerStyles} alignItems="center">
      <Grid item xs={10}>
        <Typography {...typoProps}>
          Exciting News! We&apos;ve added Past Papers for Cambridge IGCSE and
          Edexcel IGCSE Mathematics. Check them out today!
        </Typography>
      </Grid>
      <Grid
        item
        xs={2}
        container
        justifyContent={{ xs: 'center', md: 'flex-end' }}
      >
        <Button onClick={handleClose} sx={closeButtonStyles}>
          {!belowMd && 'Close'}
          <CancelIcon sx={{ fontSize: '20px' }} />
        </Button>
      </Grid>
    </Grid>
  );
};

export default TopBanner;
